import { render, staticRenderFns } from "./QA_en.vue?vue&type=template&id=9f5a099a&scoped=true&"
import script from "./QA_en.vue?vue&type=script&lang=js&"
export * from "./QA_en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5a099a",
  null
  
)

export default component.exports